import React from 'react';
import { useSelector } from 'react-redux';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import * as types from 'hellospa/page/prep-and-send/data/types';
import { ConnectFormikToStepper, StepperState } from 'hellospa/components/prep-and-send/formik-utils';
import Overlay from '../quota-overlay';

import QuotaHeader from '../quota-header/index';

/**
 * Determines if this is the last step in the Deep Integration flow
 *
 * @param isSelfSign boolean
 * @param page string
 * @returns boolean
 */
export const isLastPageInDeepIntegrationFlow = (isSelfSign: boolean, page: string): boolean => {
  if (page === 'review' || (page === 'dropin' && isSelfSign)) {
    return true;
  }
  return false;
};

export const DeepIntegrationUpsell = () => {

  const isPaidAccount = useSelector(selectors.isPaidAccount);
  const numDocsLeft = useSelector(selectors.numDocsLeft);
  const isDeepIntegration = useSelector(selectors.isDeepIntegration);
  const currentIndex = useSelector(selectors.getCurrentWorkflowPageIndex);
  const workflow = useSelector(selectors.getWorkflow);
  const isDeepIntegrationSelfSign = workflow.tags.includes(
    types.WorkflowTags.DeepIntegrationSelfSign,
  );
  const current = workflow.pages[currentIndex];

  if (isDeepIntegration
    && isPaidAccount === false
    && typeof numDocsLeft !== 'undefined') {
    if (isLastPageInDeepIntegrationFlow(isDeepIntegrationSelfSign, current.path)) {
      // For a regular flow we show the upsell on the review step
      // For a self-sign we show the upsell on the dropin step which is the last in that flow
      return <div>
        <QuotaHeader numDocsLeft={numDocsLeft} />
        {numDocsLeft === 0 && (<Overlay />)}
      </div>;
    }
  }
  return null;
};

export const DeepIntegrationQuotaValidation = () => {
  const isDeepIntegration = useSelector(selectors.isDeepIntegration);
  const isPaidAccount = useSelector(selectors.isPaidAccount);
  const numDocsLeft = useSelector(selectors.numDocsLeft);
  const currentIndex = useSelector(selectors.getCurrentWorkflowPageIndex);
  const workflow = useSelector(selectors.getWorkflow);
  const isDeepIntegrationSelfSign = workflow.tags.includes(
    types.WorkflowTags.DeepIntegrationSelfSign,
  );
  const path = workflow.pages[currentIndex].path;

  const transformState = React.useCallback((state: StepperState) => {
    if (isDeepIntegration && !isPaidAccount && numDocsLeft === 0) {
      if (isLastPageInDeepIntegrationFlow(isDeepIntegrationSelfSign, path)) {
        return {
          isValid: false,
        };
      }
    }
    return state;
  }, [isDeepIntegration, isPaidAccount, numDocsLeft, isDeepIntegrationSelfSign, path]);

  return <ConnectFormikToStepper transformState={transformState} />;
};

export default DeepIntegrationUpsell;
